import { render, staticRenderFns } from "./dossier-move-candidate.vue?vue&type=template&id=69dcd9fe&"
import script from "./dossier-move-candidate.vue?vue&type=script&lang=js&"
export * from "./dossier-move-candidate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports